// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2dZU1","signatureBlock":"Footer_signatureBlock__txYWm","signature":"Footer_signature__3DmDo"};